@if (inMfe) {
	<ng-container [ngTemplateOutlet]="tpl"></ng-container>
}
<ng-template #tpl>
	@if (currentState === 'agreements' && agreementsToBeAccepted?.length > 0) {
		<div class="agreements-container msi-content-modal-item msi-flex-col">
			<div class="inner-container msi-flex-col">
				<!-- header -->
				<div i18n class="header-bar msi-modal-header msi-text-primary">End User Agreements</div>

				<div i18n class="msi-margin-s text-start">
					By agreeing to link your solutions to Orchestrate, you acknowledge and agree that your data, including certain
					personal data, may be transferred between the systems across country borders in order to allow systems to
					communicate with each other. By choosing to link the accounts, you represent that you have the authority to
					permit such activity. For further detail, please review the documentation provided below.
				</div>

				<!-- checkbox container -->
				<div class="agreements-bottom-container msi-row">
					<div class="bottom-container-check-box">
						@if (agreementsToBeAccepted?.length > 1) {
							<!-- checks/unchecks all the checkboxes -->
							<msi-checkbox
								i18n
								id="agreement_all_agreements"
								[indeterminate]="!allSelected && someChecked"
								[checked]="allSelected"
								(change)="selectAll($event)"
								(keyup.space)="selectAll($event)"
								(keyup.enter)="selectAll($event)"
								>I have read and agree to all</msi-checkbox
							>
							@for (agreement of agreementsToBeAccepted; track agreement.agreementId) {
								<div>
									<msi-checkbox
										i18n
										id="agreement_{{ agreement.agreementId }}"
										class="ms-4"
										(change)="selectPrivacyBox(agreement.agreementId, $event)"
										(keyup.space)="selectPrivacyBox(agreement.agreementId, $event)"
										(keyup.enter)="selectPrivacyBox(agreement.agreementId, $event)"
										[checked]="agreement.checked">
										<p class="align-left">
											I agree to
											<a
												id="agreementLink-{{ agreement.agreementId }}"
												href="{{ agreement.url }}"
												target="_blank"
												class="msi-link"
												>{{ agreement.name }}</a
											>
										</p>
									</msi-checkbox>
								</div>
							}
						} @else {
							<msi-checkbox
								id="agreement_{{ agreementsToBeAccepted[0].agreementId }}"
								(change)="selectPrivacyBox(agreementsToBeAccepted[0].agreementId, $event)"
								(keyup.space)="selectPrivacyBox(agreementsToBeAccepted[0].agreementId, $event)"
								(keyup.enter)="selectPrivacyBox(agreementsToBeAccepted[0].agreementId, $event)"
								[checked]="agreementsToBeAccepted[0].checked">
								<p i18n>
									I agree to
									<a
										id="agreementLink-{{ agreementsToBeAccepted[0].agreementId }}"
										href="{{ agreementsToBeAccepted[0].url }}"
										target="_blank"
										class="msi-link"
										>{{ agreementsToBeAccepted[0].name }}</a
									>
								</p>
							</msi-checkbox>
						}
					</div>
				</div>
				<div class="bottom-container-buttons">
					<div class="button-wrapper">
						<button
							i18n
							id="cancelAcceptingAgreementsButton"
							class="msi-btn msi-btn-action"
							(click)="confirmToCloseAgreementModal()">
							Cancel
						</button>
						<button
							i18n
							id="acceptAgreementsButton"
							class="msi-btn accept-button"
							(click)="acceptButtonClick()"
							[disabled]="!allSelected">
							Accept
						</button>
					</div>
				</div>
			</div>
		</div>
	}
	@if (currentState === 'agreements-accepted') {
		<div class="msi-text-primary">
			<msi-spinner size="large" class="spinner"></msi-spinner>
			<div class="redirect-text-wrapper">
				<p i18n>Creating an agency for your tenant, please wait...</p>
				<p i18n>This may take a minute</p>
			</div>
		</div>
	}
</ng-template>

<!-- Copyright (c) Motorola Solutions Inc. All Rights Reserved. -->
